module.exports = __webpack_public_path__ + "static/social-share-494b0703a020b610e41a2130d5920b1c.png";